import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { FieldControl } from "components/Form/FieldControl";
import { Form, useNavigate, useParams } from "react-router-dom";

export function ForceCompleteAssetRetrievalDialog() {
  const params = useParams();
  const navigate = useNavigate();
  const handleDismiss = () => navigate(-1);

  return (
    <Dialog open onClose={handleDismiss}>
      <DialogTitle>Force complete asset retrieval order</DialogTitle>
      <DialogContent>
        <DialogContentText>Please provide a reason for marking the order as completed.</DialogContentText>
        <Form
          action={`/asset_retrievals/${params.retrievalId}/force_complete`}
          id="force-complete-asset-retrieval-order-form"
          method="post"
          onSubmit={handleDismiss}
        >
          <FieldControl component={TextField} fullWidth required name="forceCompleteReason" label="Reason" />
        </Form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDismiss}>Close</Button>
        <Button type="submit" form="force-complete-asset-retrieval-order-form">
          Mark as completed
        </Button>
      </DialogActions>
    </Dialog>
  );
}
